//declare variables
const mobileMenu = document.querySelector("[data-mobile-menu]");
const mobileMenuIcon = document.querySelector("[data-hamburger-button]");
const mobileMenuButton = document.querySelector(".navbar-one__menu-icon-wrapper");
const mobileNavMenuItems = mobileMenu?.querySelectorAll(".navbar__menu .menu-item-has-children > a");
const siteHeader = document.querySelector(".site-header");
const ChildSubMenu = mobileMenu?.querySelectorAll(".menu-item-has-children .menu-item-has-children");
const mobileSearch = document.querySelector("[data-search-modal]");
const SearchButton = document.querySelectorAll(".search-logo-mobile");
const ChildSubMenuInnerList = mobileMenu?.querySelectorAll(".sub-menu .sub-menu");


//update sub -> sub menu classes
ChildSubMenu.forEach((item) => {
  item.classList.add("child-menu-item-has-children");
  item.classList.remove("menu-item-has-children");
});

ChildSubMenuInnerList.forEach((item) => {
  item.classList.add("child-sub-menu");
  item.classList.remove("sub-menu");
});

const subMenuInnerList = mobileMenu?.querySelectorAll(".menu-item-has-children > a");
const childSubMenuInnerList = mobileMenu?.querySelectorAll(".child-menu-item-has-children > a");

//function - toggle attibutes open/close
const toggleAttribute = (element, attribute, condition) => {
  element.toggleAttribute(attribute, condition);
};


//function - toggle open classes on site header
const toggleDisplay = () => {
  const menu = document.querySelector("[data-mobile-menu]");
  if (menu.hasAttribute("data-open")) {
    siteHeader.classList.add("mega-menu-open");
  } else {
    siteHeader.classList.remove("mega-menu-open");
  }

  if (mobileMenuIcon.classList.contains("menu-open")) {
    mobileMenuIcon.classList.remove("menu-open");
  } else {
    mobileMenuIcon.classList.add("menu-open");
  }
};

//Add a click event to each sub menu
subMenuInnerList.forEach((navItemButton) => {
  navItemButton.addEventListener("click", (e) => {
    e.preventDefault();
    subControls(navItemButton, subMenuInnerList);
  });
});

//Add a click event to each sub menu -> sub menu
childSubMenuInnerList.forEach((navItemButton) => {
  navItemButton.addEventListener("click", (e) => {
    e.preventDefault();
    childSubControls(navItemButton, childSubMenuInnerList);
  });
});

//function - add/remove classes that control the sub menu
const subControls = (navButton_sub, SubList) => {
  const parent = navButton_sub.parentElement;
  if (parent.classList.contains("active")) {
    parent.classList.remove("active");
    navButton_sub.classList.remove("open");

    childSubMenuInnerList.forEach((child) => {
      child.parentElement.classList.remove("active");
      child.classList.remove("open");
    });
  } else {
    childSubMenuInnerList.forEach((child) => {
      child.parentElement.classList.remove("active");
      child.classList.remove("open");
    });

    SubList.forEach((subItem) => {
      subItem.parentElement.classList.remove("active");
      subItem.classList.remove("open");
    });

    parent.classList.add("active");
    navButton_sub.classList.add("open");
  }
};

//function - add/remove classes that control the sub -> menu
const childSubControls = (navButton_sub, childSubList) => {
  const parent = navButton_sub.parentElement;
  if (parent.classList.contains("active")) {
    parent.classList.remove("active");
    navButton_sub.classList.remove("open");
  } else {
    childSubList.forEach((child) => {
      child.parentElement.classList.remove("active");
      child.classList.remove("open");
    });

    parent.classList.add("active");
    navButton_sub.classList.add("open");
  }
};

//function - handels menu calsses when hamburger clicked
const toggleMenu = (open) => {
  toggleAttribute(mobileMenu, "data-open", open);
  toggleAttribute(document.body, "tabindex", open ? "-1" : null);
  toggleDisplay();
  document.body.classList.toggle("overflow-hidden");

  if (!open) {
    mobileNavMenuItems?.forEach((itemLink) => {
      const item = itemLink.closest(".menu-item-has-children");
      const subMenu = item.querySelector(":scope > .sub-menu");
      toggleAttribute(subMenu);
    });

    childSubMenuInnerList.forEach((child) => {
      child.parentElement.classList.remove("active");
      child.classList.remove("open");
    });

    subMenuInnerList.forEach((subItem) => {
      subItem.parentElement.classList.remove("active");
      subItem.classList.remove("open");
    });
  } else {
    SearchButton.forEach((button) => {
      button.classList.remove("open");
      mobileSearch.classList.remove("open");
    });
  }
};

[mobileMenuButton].forEach((button, index) => {
  button?.addEventListener("click", () => {
    if (index === 0) {
      // Hamburger button
      const isOpen = mobileMenu.hasAttribute("data-open");
      toggleMenu(!isOpen);
    } else {
      // Close button
      mobileNavMenuItems?.forEach((itemLink) => {
        const otherItem = itemLink.closest(".menu-item-has-children");
        otherItem.classList.remove("open");
      });
      toggleMenu(false);
    }
  });
});



//search button fuctionality
//add a click event to the mobile search icon
SearchButton.forEach((button) => {
  button.addEventListener("click", (e) => {
    childSubMenuInnerList.forEach((child) => {
      child.parentElement.classList.remove("active");
      child.classList.remove("open");
    });

    subMenuInnerList.forEach((subItem) => {
      subItem.parentElement.classList.remove("active");
      subItem.classList.remove("open");
    });
    toggleAttribute(mobileMenu, "data-open", closed);
    mobileMenuIcon.classList.remove("menu-open");
    seach_toggle(button);
  });
});


//control the search modal classes
const seach_toggle = (button) => {
  if (mobileSearch.classList.contains("open")) {
    button.classList.remove("open");
    mobileSearch.classList.remove("open");
  } else {
    button.classList.add("open");
    mobileSearch.classList.add("open");
  }
};
